module.exports = __webpack_public_path__ + "static/strega-nona-6459ef8579379c87411091d4b4e5c912.jpg";